// extracted by css-extract-rspack-plugin
var _1 = "DraggableInventoryItem-m_cantDrag-Q3dOPgdG";
var _2 = "DraggableInventoryItem-m_engram-BlmgtRCV";
export { _1 as "cantDrag", _2 as "engram" }
